import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type AppState, type BaseAppState, type EntityRef, Status } from "@client/types";
import { type Dispatch } from "redux";
import { initAction } from "../actions";
import api from "./api";
import { localStateSelector } from "./selectors";
import { type MemberAffiliate } from "./types";

export enum Actions {
  InitBegin = "MEMBER_AFFILIATE_INIT_BEGIN",
  InitFailure = "MEMBER_AFFILIATE_INIT_FAILURE",
  InitSuccess = "MEMBER_AFFILIATE_INIT_SUCCESS"
}

export type InitBeginActionData = EntityRef;
export type InitSuccessActionData = {
  offers: MemberAffiliate.Api.Offer[];
};
export const _init = initAction<BaseAppState, InitBeginActionData, InitSuccessActionData>({
  types: {
    begin: Actions.InitBegin,
    failure: Actions.InitFailure,
    success: Actions.InitSuccess
  },
  action: async (state: AppState, dispatch: any, params: InitBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, params);

    return api.init(apiInfo);
  }
});

export type InitArgs = EntityRef & {};
export const init = (args: InitArgs) => (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
  const state = getState();
  const localState = localStateSelector(state, args);
  if (localState.status === Status.None) {
    dispatch(_init(args));
  }
};
